var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79123 0.791224C6.79123 0.354243 6.43699 0 6 0C5.56302 0 5.20878 0.354243 5.20878 0.791224V1.38464H4.76774C3.00721 1.38464 1.55009 2.75347 1.44019 4.51057L1.26533 7.30632C1.19866 8.37226 0.840799 9.39947 0.230717 10.2761C-0.320515 11.0681 0.170219 12.1621 1.12834 12.2771L3.82414 12.6005V13.4508C3.82414 14.6525 4.79831 15.6267 6 15.6267C7.2017 15.6267 8.17587 14.6525 8.17587 13.4508V12.6005L10.8717 12.2771C11.8298 12.1621 12.3205 11.0681 11.7693 10.2761C11.1592 9.39947 10.8013 8.37226 10.7347 7.30632L10.5598 4.51057C10.4499 2.75347 8.99279 1.38464 7.23226 1.38464H6.79123V0.791224ZM5.01097 13.4508C5.01097 13.997 5.45378 14.4398 6 14.4398C6.54623 14.4398 6.98903 13.997 6.98903 13.4508V12.8574H5.01097V13.4508Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.059a35a9e1f180bd078ceb169783c8f5.svg";
export { ForwardRef as ReactComponent };